import { carouselData } from '@/mocks/tanhua';

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-950 mb-3">
            焦点专题
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            编辑精选的探花系列焦点专题，深入探索每一个探花主题
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {carouselData.map((item) => (
            <article
              key={item.id}
              className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/70 hover:border-accent-200 transition-colors cursor-pointer flex flex-col"
            >
              <div className="relative overflow-hidden aspect-[16/10]">
                <img
                  src={item.image}
                  alt={`探花焦点专题 - ${item.title}`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 bg-accent-500 text-background-50 text-xs font-medium rounded whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <div className="p-5 flex flex-col flex-1">
                <p className="text-xs text-primary-500 font-medium mb-2 whitespace-nowrap">
                  {item.subtitle}
                </p>
                <h3 className="text-lg md:text-xl font-heading text-foreground-950 mb-3 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed flex-1">
                  {item.desc}
                </p>
                <div className="mt-4 flex items-center gap-2 text-sm text-primary-500 font-medium cursor-pointer">
                  <span className="whitespace-nowrap">查看专题</span>
                  <i className="ri-arrow-right-line"></i>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}